import { SweepFieldTypes } from './enums/SweepFieldTypes';
import { SfdcDisplayType } from './fields';
export const SF_TEXT_FIELD_TYPES = [
  SfdcDisplayType.PICKLIST,
  SfdcDisplayType.MULTIPICKLIST,
  SfdcDisplayType.STRING,
  SfdcDisplayType.TEXTAREA,
  SfdcDisplayType.URL,
  SfdcDisplayType.PHONE,
  SfdcDisplayType.EMAIL,
  SfdcDisplayType.LONGTEXTAREA,
  SfdcDisplayType.ENCRYPTEDSTRING,
];

export const SF_NUMBERFIELD_TYPES = [
  SfdcDisplayType.NUMBER,
  SfdcDisplayType.CURRENCY,
  SfdcDisplayType.PERCENT,
  SfdcDisplayType.DOUBLE,
  SfdcDisplayType.INTEGER,
];

/* Deprecated */

export const DATE_FIELD_TYPES = [SweepFieldTypes.Date, SweepFieldTypes.FormulaDate];
export const DATETIME_FIELD_TYPES = [SweepFieldTypes.DateTime, SweepFieldTypes.FormulaDateTime];
export const TIME_FIELD_TYPES = [SweepFieldTypes.Time, SweepFieldTypes.FormulaTime];

export const NUMBER_FIELD_TYPES = [
  SweepFieldTypes.Number,
  SweepFieldTypes.FormulaNumber,
  SweepFieldTypes.Percent,
  SweepFieldTypes.FormulaPercent,
  SweepFieldTypes.Currency,
  SweepFieldTypes.FormulaCurrency,
  SweepFieldTypes.Summary,
];
